import {atom, selector, useRecoilRefresher_UNSTABLE} from "recoil";
import axios from "axios";
import {getMetaData} from "../redux/actions/metadataActions";

export const metadataAtom = atom({
  key: 'Metadata',
  default: selector({
    key: 'Metadata/Default',
    get: async () => {
      return await axios.get("/api/metadata")
        .then(function (response) {
          console.log("Metadata", response.data)
          return response.data;
        })
        .catch(function (error) {
          // Not logged in!
          return undefined;
        })
    }
  })
});